<template>
  <section>
    <NonLogin />
    <OrderProgress
      ref="progress"
      v-model="progressPamars"
      :progressConfig="progressConfig"
      :checkNextStep="true"
      :cancelBtnHide="cancelBtnHide"
      subBtnName="完成"
      @nextStep="nextStep"
    />
    <section class="forgetpwd-content-box" v-show="progressPamars.step === 1">
      <CheckAccountForm ref="checkAccountForm" />
    </section>
    <section class="forgetpwd-content-box" v-show="progressPamars.step === 2">
      <NewpwdForm ref="newpwdForm" />
    </section>
    <section class="forgetpwd-content-box" v-show="progressPamars.step === 3">
      <SuccessPage finishText="设置成功" successText="新登录密码设置成功。" />
    </section>
  </section>
</template>

<script>
import { findpwdSaveTenantRegister } from 'api';
import NonLogin from 'components/nonlogin/nonlogin';
import OrderProgress from 'components/progress/progress';
import SuccessPage from 'components/successPage/successPage';
import CheckAccountForm from './checkAccount';
import NewpwdForm from './newpwd';
import pageDataMixin from '@qx/mixin/pageData';
const IMG_VALIDATE_ACC = require('../../assets/images/register/success.png');
const IMG_VALIDATE_ACC_ACTIVE = require('../../assets/images/register/successActive.png');
const IMG_NEW_PWD = require('../../assets/images/register/success.png');
const IMG_NEW_PWD_ACTIVE = require('../../assets/images/register/successActive.png');
const IMG_SUCCESS = require('../../assets/images/register/success.png');
const IMG_SUCCESS_ACTIVE = require('../../assets/images/register/successActive.png');
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    NonLogin,
    OrderProgress,
    SuccessPage,

    CheckAccountForm,
    NewpwdForm,
  },
  data () {
    return {
      cancelBtnHide: false,
      progressPamars: {
        step: 1,
      },
      progressConfig: [
        {
          label: '验证账号',
          normalImgUrl: IMG_VALIDATE_ACC,
          activeImgUrl: IMG_VALIDATE_ACC_ACTIVE,
        },
        {
          label: '设置新密码',
          normalImgUrl: IMG_NEW_PWD,
          activeImgUrl: IMG_NEW_PWD_ACTIVE,
        },
        {
          label: '注册完成',
          normalImgUrl: IMG_SUCCESS,
          activeImgUrl: IMG_SUCCESS_ACTIVE,
        },
      ],
      formComponents: [
        'checkAccountForm',
        'newpwdForm',
      ],
      editParams: {
      },
    };
  },
  methods: {
    editApi: findpwdSaveTenantRegister,
    async nextStep (step) {
      let isGoNextStep = true;
      switch (step) {
        case 1:
          isGoNextStep = await this.checkComponetsSub([
            'checkAccountForm',
          ]);
          if (isGoNextStep) {
            this.$refs.progress.toNextStep();
          }
          break;
        case 2:
          isGoNextStep = await this.checkComponetsSub([
            'newpwdForm',
          ]);
          if (isGoNextStep) {
            await this.sub();
          }
          break;
        case 3:
          this.$router.push({ path: '/login' });
          break;
        default:
          break;
      }
    },
    // 提交成功之后跳转到最后一步
    handleSubSucc (res) {
      if (res === 'Y') {
        this.$refs.progress.toNextStep();
        this.cancelBtnHide = true;
      }
    },
    // 检测每个步骤
    async checkComponetsSub (componentListName) {
      let isGoNextStep = true;
      for (let i = 0; i < componentListName.length; i++) {
        const formData = await this.$refs[componentListName[i]].sub();
        // 如果有不通过验证的，formData 会返回 null，以此来判断是否可以前往下一步
        if (!formData) {
          isGoNextStep = false;
          break;
        }
      }
      return isGoNextStep;
    },
  },
};
</script>

<style lang="scss" scoped>
.forgetpwd-content-box {
  margin: 0 auto;
  padding: 20px 10px;
  display: flex;
  justify-content: center;
  background-color: #ffffff;
}
</style>

